import React from "react";
import { FaLeaf, FaUserGraduate, FaCogs } from "react-icons/fa";

function BenefitsOFCardano() {
  const features = [
    {
      title: "Eco-Friendly and Secure",
      desc: "Cardano’s PoS mechanism provides a sustainable, secure platform for decentralized solutions.",
      icon: <FaLeaf />,
    },
    {
      title: "Peer-Reviewed Foundation",
      desc: "Built on academic rigor, Cardano’s architecture ensures reliability and long-term scalability.",
      icon: <FaUserGraduate />,
    },
    {
      title: "End-to-End Solutions",
      desc: "Xeer Technology offers full-cycle development, from concept to deployment, maintenance, and support.",
      icon: <FaCogs />,
    },
  ];

  return (
    <div
      className="services-area pt-100 pb-100"
      style={{ background: "#f8fbff" }}
    >
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-lg-8 offset-lg-2">
            <h4 className="sub-title text-primary fw-bold mb-2">
              Platform Capabilities
            </h4>
            <h2 className="title fw-bold" style={{ fontSize: "42px" }}>
              Benefits of Cardano Development with Xeer Technology
            </h2>
          </div>
        </div>

        <div className="row g-4">
          {features.map((feature, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="card border-0 h-100 p-5 text-center"
                style={{
                  borderRadius: "24px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
                  transition:
                    "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                  border: "1px solid #f0f0f0",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(33, 150, 243, 0.1)";
                  e.currentTarget.style.borderColor = "rgba(33, 150, 243, 0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.03)";
                  e.currentTarget.style.borderColor = "#f0f0f0";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "70px",
                    height: "70px",
                    fontSize: "28px",
                    backgroundColor: "#f0f7ff",
                    // color: "#2196f3",
                    borderRadius: "20px",
                    transform: "rotate(-5deg)",
                  }}
                >
                  {feature.icon}
                </div>

                <h5
                  className="fw-extrabold mb-3"
                  style={{ fontSize: "24px", fontWeight: "600" }}
                >
                  {feature.title}
                </h5>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    lineHeight: "1.7",
                    marginBottom: 0,
                  }}
                >
                  {feature.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BenefitsOFCardano;
